<template>
  <div class="yhc-ef-section-title">
    <slot name="title-before" />
    <div class="yhc-ef-section-title--inner">
      <slot />
    </div>
    <slot name="title-after" />
  </div>
</template>
<script lang="ts">
/**
 * Style のみを提供する Component
 */
export default {
  name: 'YhcEFSectionTitle',
}
</script>

<style lang="scss">
/**
 * セクションタイトル
 */
.yhc-ef-section-title {
  background-color: var(--yhc-color);
  text-align: center;
  padding: var(--yhc-base-pad-lg) 0;
  color: white;
  position: relative;
  font-weight: bold;
  margin-bottom: var(--yhc-base-pad-xl);
  margin-top: var(--yhc-base-pad);

  @media screen and (max-width: 757px) {
    padding: var(--yhc-base-pad) 0;
  }
  // before 要素で 下三角形 を表示
  &:before {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -10px;
    border-width: 10px;
    border-style: solid;
    border-color: var(--yhc-color) transparent transparent transparent;
  }

  .yhc-ef-section-title--inner {
    font-size: 22px;

    @media screen and (max-width: 757px) {
      font-size: 18px;
    }
  }
}
</style>
